export const DEFAULT_BASE_CURRENCY = "SEK";
export const AMOUNT_MAX_VALUE = 100000000;
export const AMOUNT_MIN_VALUE = 0;
